// @flow
import Vue from 'vue'
import type { B2bClientInterface } from '../../../services/b2b/b2b-client-interface'
import type { Company } from '../../../types/company'
import type { CompanyState } from './index'
import * as mutationTypes from './mutation-types'
import { CUSTOMER_TYPE_COMMERCIAL } from '../../../types/contact-details'
import type { PropertyError } from '../../../types/validation-error-result'
import {buildPrimaryAddress} from '../../../types/primary-address'
import {buildVisitAddress} from '../../../types/visit-address'
import {buildPostAddress} from '../../../types/post-address'
import type {PrimaryAddress} from '../../../types/primary-address'
import type {VisitAddress} from '../../../types/visit-address'
import type {PostAddress} from '../../../types/post-address'
import {Dispatch} from 'vuex'
import type {CompanySelfServiceStatus} from '../../../types/company-self-service-status'

export default {
  loadCompany: async ({ dispatch, commit }: { dispatch: Dispatch, commit: (string, Company) => void }): Promise<void> => {
    const client: B2bClientInterface = Vue.prototype.$container.b2bClient
    commit(mutationTypes.SET_COMPANY, await client.getCompany())
    dispatch('createDefaultAddressObjects')
  },

  createDefaultAddressObjects: async (
    { state, commit }: { state: CompanyState, commit: (string, PrimaryAddress | VisitAddress | PostAddress) => void }
  ): Promise<void> => {
    if (state.company.primaryAddress === null) {
      commit(mutationTypes.SET_PRIMARY_ADDRESS, buildPrimaryAddress())
    }
    if (state.company.visitAddress === null) {
      commit(mutationTypes.SET_VISIT_ADDRESS, buildVisitAddress())
    }
    if (state.company.postAddress === null) {
      commit(mutationTypes.SET_POST_ADDRESS, buildPostAddress())
    }
  },

  loadSelfServiceStatus: async ({ commit }: { commit: (string, CompanySelfServiceStatus) => void }): Promise<void> => {
    const client: B2bClientInterface = Vue.prototype.$container.b2bClient
    commit(mutationTypes.SET_SELF_SERVICE_STATUS, await client.getCompanySelfServiceStatus())
  },

  submitCompanyContactDetails: async (
    { state, commit }: { state: CompanyState, commit: (string, PropertyError[]) => void }, payload: Company
  ): Promise<void> => {
    const client: B2bClientInterface = Vue.prototype.$container.b2bClient
    const partialPayload = {
      ...payload
    }
    partialPayload['customerType'] = CUSTOMER_TYPE_COMMERCIAL
    delete partialPayload.postAddress
    delete partialPayload.primaryAddress
    delete partialPayload.visitAddress

    try {
      await client.patchCompanyContactDetails(partialPayload)
    } catch (error) {
      if (error.validationErrors) {
        commit(mutationTypes.SET_VALIDATION_ERRORS, error.validationErrors)
      }
      throw error
    }
  },

  submitCompanyAddresses: async (
    { state, commit }: { state: CompanyState, commit: (string, PropertyError[]) => void }, payload: Company
  ): Promise<void> => {
    const partialPayload = {
      customerType: CUSTOMER_TYPE_COMMERCIAL,
      postAddress: payload.postAddress,
      primaryAddress: payload.primaryAddress,
      visitAddress: payload.visitAddress
    }
    const client: B2bClientInterface = Vue.prototype.$container.b2bClient

    try {
      await client.patchCompanyAddresses(partialPayload)
    } catch (error) {
      if (error.validationErrors) {
        commit(mutationTypes.SET_VALIDATION_ERRORS, error.validationErrors)
      }
      throw error
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/company/actions.js